import { render, staticRenderFns } from "./NeedDescriptionInstructions.vue?vue&type=template&id=4dfdbce8&"
import script from "./NeedDescriptionInstructions.vue?vue&type=script&lang=js&"
export * from "./NeedDescriptionInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NeedDescriptionInstructions.vue"
export default component.exports